import React from 'react'
import dayjs from 'dayjs'
import CellWrapper from './CellWrapper'

const format = 'MM/DD/YYYY HH:mm:ss'
const dateToString = (date) =>
    date ? dayjs(date).format(format).toString() : null

const DateTimeCell = ({value}) => {
    return <CellWrapper>{dateToString(value)}</CellWrapper>
}

export default DateTimeCell